/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getClinicalDictionaries } from 'app/entities/clinical-dictionary/clinical-dictionary.reducer';
import { AddedByType } from 'app/shared/model/enumerations/added-by-type.model';
import { createEntity, getEntity, reset, updateEntity } from './catalog-definitions.reducer';

export const CatalogDefinitionsUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const clinicalDictionaries = useAppSelector(state => state.clinicalDictionary.entities);
  const catalogDefinitionsEntity = useAppSelector(state => state.catalogDefinitions.entity);
  const loading = useAppSelector(state => state.catalogDefinitions.loading);
  const updating = useAppSelector(state => state.catalogDefinitions.updating);
  const updateSuccess = useAppSelector(state => state.catalogDefinitions.updateSuccess);
  const addedByTypeValues = Object.keys(AddedByType);

  const handleClose = () => {
    navigate(`/catalog-definitions${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getClinicalDictionaries({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...catalogDefinitionsEntity,
      ...values,
      catalogType: clinicalDictionaries.find(it => it.id.toString() === values.catalogType?.toString()),
      category: clinicalDictionaries.find(it => it.id.toString() === values.category?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          addedByType: 'DOCTOR',
          modifiedByType: 'DOCTOR',
          ...catalogDefinitionsEntity,
          catalogType: catalogDefinitionsEntity?.catalogType?.id,
          category: catalogDefinitionsEntity?.category?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.catalogDefinitions.home.createOrEditLabel" data-cy="CatalogDefinitionsCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.catalogDefinitions.home.createOrEditLabel">
              Create or edit a CatalogDefinitions
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="catalog-definitions-id"
                  label={translate('tinyMedicRestApp.catalogDefinitions.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.catalogDefinitions.code')}
                id="catalog-definitions-code"
                name="code"
                data-cy="code"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <UncontrolledTooltip target="codeLabel">
                <Translate contentKey="tinyMedicRestApp.catalogDefinitions.help.code" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.catalogDefinitions.name')}
                id="catalog-definitions-name"
                name="name"
                data-cy="name"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <UncontrolledTooltip target="nameLabel">
                <Translate contentKey="tinyMedicRestApp.catalogDefinitions.help.name" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.catalogDefinitions.description')}
                id="catalog-definitions-description"
                name="description"
                data-cy="description"
                type="text"
              />
              <UncontrolledTooltip target="descriptionLabel">
                <Translate contentKey="tinyMedicRestApp.catalogDefinitions.help.description" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.catalogDefinitions.active')}
                id="catalog-definitions-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <UncontrolledTooltip target="activeLabel">
                <Translate contentKey="tinyMedicRestApp.catalogDefinitions.help.active" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.catalogDefinitions.draft')}
                id="catalog-definitions-draft"
                name="draft"
                data-cy="draft"
                check
                type="checkbox"
              />
              <UncontrolledTooltip target="draftLabel">
                <Translate contentKey="tinyMedicRestApp.catalogDefinitions.help.draft" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.catalogDefinitions.cursor')}
                id="catalog-definitions-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.catalogDefinitions.lastUpdated')}
                id="catalog-definitions-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
              />
              <UncontrolledTooltip target="lastUpdatedLabel">
                <Translate contentKey="tinyMedicRestApp.catalogDefinitions.help.lastUpdated" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.catalogDefinitions.microSec')}
                id="catalog-definitions-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <UncontrolledTooltip target="microSecLabel">
                <Translate contentKey="tinyMedicRestApp.catalogDefinitions.help.microSec" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.catalogDefinitions.timestampEntry')}
                id="catalog-definitions-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
              />
              <UncontrolledTooltip target="timestampEntryLabel">
                <Translate contentKey="tinyMedicRestApp.catalogDefinitions.help.timestampEntry" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.catalogDefinitions.addedById')}
                id="catalog-definitions-addedById"
                name="addedById"
                data-cy="addedById"
                type="text"
              />
              <UncontrolledTooltip target="addedByIdLabel">
                <Translate contentKey="tinyMedicRestApp.catalogDefinitions.help.addedById" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.catalogDefinitions.modifiedById')}
                id="catalog-definitions-modifiedById"
                name="modifiedById"
                data-cy="modifiedById"
                type="text"
              />
              <UncontrolledTooltip target="modifiedByIdLabel">
                <Translate contentKey="tinyMedicRestApp.catalogDefinitions.help.modifiedById" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.catalogDefinitions.addedByType')}
                id="catalog-definitions-addedByType"
                name="addedByType"
                data-cy="addedByType"
                type="select"
              >
                {addedByTypeValues.map(addedByType => (
                  <option value={addedByType} key={addedByType}>
                    {translate(`tinyMedicRestApp.AddedByType.${addedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <UncontrolledTooltip target="addedByTypeLabel">
                <Translate contentKey="tinyMedicRestApp.catalogDefinitions.help.addedByType" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.catalogDefinitions.modifiedByType')}
                id="catalog-definitions-modifiedByType"
                name="modifiedByType"
                data-cy="modifiedByType"
                type="select"
              >
                {addedByTypeValues.map(addedByType => (
                  <option value={addedByType} key={addedByType}>
                    {translate(`tinyMedicRestApp.AddedByType.${addedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <UncontrolledTooltip target="modifiedByTypeLabel">
                <Translate contentKey="tinyMedicRestApp.catalogDefinitions.help.modifiedByType" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.catalogDefinitions.tenantId')}
                id="catalog-definitions-tenantId"
                name="tenantId"
                data-cy="tenantId"
                type="text"
              />
              <UncontrolledTooltip target="tenantIdLabel">
                <Translate contentKey="tinyMedicRestApp.catalogDefinitions.help.tenantId" />
              </UncontrolledTooltip>
              <ValidatedField
                id="catalog-definitions-catalogType"
                name="catalogType"
                data-cy="catalogType"
                label={translate('tinyMedicRestApp.catalogDefinitions.catalogType')}
                type="select"
              >
                <option value="" key="0" />
                {clinicalDictionaries
                  ? clinicalDictionaries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="catalog-definitions-category"
                name="category"
                data-cy="category"
                label={translate('tinyMedicRestApp.catalogDefinitions.category')}
                type="select"
              >
                <option value="" key="0" />
                {clinicalDictionaries
                  ? clinicalDictionaries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/catalog-definitions" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default CatalogDefinitionsUpdate;
